<template>
  <v-expansion-panels accordion class="expansion-panels--primary">
    <v-expansion-panel>
      <v-expansion-panel-header>
        {{ localize(value.title) }}
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <v-alert
          v-if="localize(value.subtitle)"
          dense
          text
          type="info"
          class="mb-6"
        >
          <span v-html="localize(value.subtitle)"></span>
        </v-alert>

        <grouped-element
          v-for="(item, index) in value.elements"
          v-model="value.elements[index]"
          :key="`form_element_${item.id}`"
          :readOnly="readOnly"
          :printView="printView"
          :isGroupedElement="true"
          @errorOnSave="$emit('errorOnSave')"
          ref="formElements"
        ></grouped-element>
      </v-expansion-panel-content>

    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import formElement from '@/components/forms/questionnaire/element.vue';

import { mapActions, mapState } from 'vuex';

export default {
  name: 'groupElement',
  props: {
    value: {
      type: Object,
      required: true
    },

    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },

    printView: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    groupedElement: formElement
  },

  data: () => ({
    conditionIsMet: false
  }),

  computed: {
    ...mapState('feedbacks', {
      feedbackData: 'currentFeedbackData'
    }),

    conditionLabel() {
      if (this.conditionIsMet) {
        return this.$t('yes');
      } else {
        return this.$t('no');
      }
    }
  },

  watch: {
    conditionIsMet() {
      if (this.conditionIsMet) {
        this.value.value = 1;
      } else {
        this.value.value = 0;
      }
    }
  },

  mounted() {
    if (this.value.value === 1) {
      this.conditionIsMet = true;
    }

    if (
      this.feedbackData &&
      this.feedbackData.isComparison &&
      this.value.hasCondition
    ) {
      for (let comparisonData of this.feedbackData.comparisonData) {
        const comparisonItem = comparisonData.values.filter(
          (x) => x.elementId === this.value.id
        );

        if (comparisonItem.length === 0) {
          continue;
        }

        if (comparisonItem[0].value === 1) {
          this.value.value = 1;
          this.conditionIsMet = true;

          break;
        }
      }
    }
  },

  methods: {
    ...mapActions({
      saveItem: 'feedbacks/saveItemValue'
    }),

    itemChanged() {
      var itemValue = this.conditionIsMet ? 1 : 0;

      this.saveItem({
        feedbackId: this.$route.params.id,
        elementId: this.value.id,
        value: itemValue,
        accessToken: this.$route.params.accessToken
      });
    },

    validate() {
      // const results = [];
      // console.log(this.$refs);
      // for (const element of this.$refs.formElements) {
      //   const elementResult = element.validate();
      //   if (elementResult !== undefined) {
      //     results.push(elementResult);
      //   }
      // }

      // return results;
      return [];
    }
  }
};
</script>

<style lang="scss" scoped>
.expanded {
  background-color: var(--element-background-secondary);
  margin-left: -1em;
  margin-right: -1em;
  padding: 1em;
}

.question-group {
  .questionnaire-element-wrapper:last-of-type {
    margin-bottom: 1em;
  }
}
</style>
